import { Model } from 'modules/core/lib/mobx-rest'

import { Provider, Status } from 'modules/ats/lib/enums'

interface IPromotion {
  ats_job_posting_id: number
  provider: Provider
  status?: Status
  data?: PromotionData
}

export type PromotionData = Record<string, unknown>

class Promotion extends Model<IPromotion> {
  static urlRoot() {
    return '/ats/promotions'
  }

  async cancel() {
    await this.rpc('cancel', {
      ats_job_posting_id: this.attributes.ats_job_posting_id,
      provider: Provider.Vonq,
    })
    this.set({ status: Status.Offline })
  }
}

export default Promotion
